import { type UseQueryResult, useQuery } from 'react-query';
import {
  TransactionService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Transactions_TransactionDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetTransactionByIdForVendor = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId?: string,
  transactionId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Transactions_TransactionDto | undefined,
  unknown
> => {
  return useQuery(
    ['getTransactionByIdForVendor', companyId, transactionId],
    async () => {
      if (!companyId || !transactionId) return undefined;
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTransactionByIdForVendor(
          companyId,
          transactionId
        )
      );
    },
    {
      enabled: !!companyId && !!transactionId,
    }
  );
};

export default useGetTransactionByIdForVendor;
